export default __webpack_public_path__ + "static/media/3.33ed58f4.jpg";